import CustomizeDataEditorPropertyValue from "./CustomizeDataEditorPropertyValue";

export default CustomizeDataEditorPropertyValue;
export { CustomizeDataEditorPropertyValue };
